export default __webpack_public_path__ + "static/media/add-size-new.6ce3d646.svg";